export const jobTypesEn = {
  jobTypes: {
    // Database keys (snake_case)
    'full_time': 'Full Time',
    'part_time': 'Part Time',
    'half_time': 'Half Time',
    'freelance': 'Freelance',
    'internship': 'Internship',
    'contract': 'Contract',
    'temporary': 'Temporary',
    'seasonal': 'Seasonal',
    // Legacy display names (for backward compatibility)
    'Half Time': 'Half Time',
    'Full Time': 'Full Time',
    'Freelance': 'Freelance',
    'Internship': 'Internship'
  }
};